import { useQuery } from '@tanstack/react-query';

import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';

import { listRecentMemories, type MemoryLevel } from '../api/memory.client.js';

export function useRecentMemories(level: MemoryLevel, limit = 20) {
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId ?? 'anonymous';

  return useQuery({
    queryKey: ['memory', 'recent', workspaceId, level, limit],
    queryFn: () => listRecentMemories(level, limit),
    enabled: scope !== null,
  });
}
